import { FormEvent } from 'react';
import { FormControl } from 'react-bootstrap';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { GenericFormFieldBaseProps } from 'components/forms/genericFormField/GenericFormField.types';
import SelectTextField from 'components/forms/selectTextField/SelectTextField';
import { Currency } from 'models/Currency';
import { AirbnbFeeType, FeeAmountTypeEnum } from 'models/PropertyFees';
import { PropertyFeeFormSchemaType } from './PropertyFeeModal.schema';
import useFormData from './useFormData';
import { AIRBNB_PERCENT_FEE_TYPES } from './PropertyFeeModal.constants';

interface AmountTypeFieldProps {
  labelInputSizes: Pick<GenericFormFieldBaseProps, 'colSmInput' | 'colSmLabel'>;
  propertyCurrency: Currency;
}

const AmountTypeField = ({
  labelInputSizes,
  propertyCurrency,
}: AmountTypeFieldProps) => {
  const { t } = useTranslation();
  const { isTypeFee } = useFormData();
  const { setValue } = useFormContext();
  const { airbnbMappingType, airbnbUnitMappingType } =
    useWatch<PropertyFeeFormSchemaType>();

  const handleAmountTypeChange = (e: FormEvent<FormControl>) => {
    const scopeValue = (e.target as HTMLSelectElement).value;

    // if is changing to percentage amount type, then it should clear the airbnb
    // fields, if not supported.
    if (
      scopeValue === FeeAmountTypeEnum.TAX &&
      airbnbMappingType &&
      !AIRBNB_PERCENT_FEE_TYPES.includes(airbnbMappingType as AirbnbFeeType)
    ) {
      setValue('airbnbMappingType', null, { shouldDirty: true });

      if (airbnbUnitMappingType) {
        setValue('airbnbUnitMappingType', null, { shouldDirty: true });
      }
    }
  };

  return (
    <SelectTextField
      required
      label={
        isTypeFee
          ? t('pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.feeValue')
          : t('pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.taxValue')
      }
      textFieldName="amount"
      selectFieldName="amountType"
      position="left"
      {...labelInputSizes}
      options={[
        { value: FeeAmountTypeEnum.AMOUNT, label: propertyCurrency },
        { value: FeeAmountTypeEnum.TAX, label: '%' },
      ]}
      selectFieldOnChangeHandler={handleAmountTypeChange}
    />
  );
};

export default AmountTypeField;
